import axios from 'axios';
import { QueryClient, QueryCache } from '@tanstack/react-query';
import { getBackendConfig } from '@app/common';
import SentryLogger from '@app/sentry';

export const createNewQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        retry: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
      },
    },
    queryCache: new QueryCache({
      onError: (error, query) => {
        // Pass the error itself as the exception: SentryLogger.error forwards
        // its arguments to Sentry.captureException(exception, hint), so a
        // string here would capture a message with no stack and drop the error.
        SentryLogger.error(error, {
          extra: {
            action: 'react-query-query-error',
            queryKey: query.queryKey,
          },
        });
      },
    }),
  });

export const queryClient = createNewQueryClient();

export const api = axios.create(getBackendConfig());
